
export * from '../../../frontend-js-dependencies-web/__liferay__/exports/fuzzy.js';

import __default__ from '../../../frontend-js-dependencies-web/__liferay__/exports/fuzzy.js';
export default __default__;
